import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  baseUrl = environment.baseApiUrl;
  endpointUrl = 'preferences/template';
  private static loaderEnabled: boolean = false;
  private refreshClickEvent = new Subject<any>();
  private privelegeClickEvent = new Subject<any>();
  constructor(private http: HttpClient) {
  }
  onClickSendRefreshEvent(route) {
    this.refreshClickEvent.next(route);
  }

  getRefreshEvent(): Observable<any> {
    return this.refreshClickEvent.asObservable();
  }
  getColumnSettings(preferenceId: Number) {
    return this.http.get<any>(this.baseUrl + 'preferences/columns-list?preference_type=' + preferenceId);
  }
  getAstroHandbook(){
    return this.http.get<any>(this.baseUrl + 'document/v1/hand-book');
  }
  getNotificationList() {
    return this.http.get<any>(this.baseUrl + 'notification/list');
  }
  getAnnouncementFile(id) {
    return this.http.get<any>(this.baseUrl + `notification/v1/announcement/file/${id}`);
  }
  getD365VendorFile(file_name: string) {
    return this.http.get<any>(this.baseUrl + `vendor/v1/data/receiver/log/${file_name}`);
  }
  getNotificationCount() {
    return this.http.get<any>(this.baseUrl + 'notification/count');
  }
  postNotificationRead(body){
    return this.http.post(this.baseUrl + 'notification/read', body);
  }
  createFilterTemplate(templateBody: {}) {
    return this.http.post(this.baseUrl + this.endpointUrl, templateBody);
  }
  requestUserAccess(body){
    return this.http.post(this.baseUrl+'user/v1/user-register',body);
  }
  getProfileDetails() {
    return this.http.get<any>(this.baseUrl + 'user/v1/profile');
  }
  getUserListJSONDetails() {
    return this.http.get<any>(this.baseUrl + 'user/v1/json-info');
  }
  getAnnouncementList(body:{}) {
    return this.http.post<any>(environment.baseApiUrl + 'notification/v1/announcement/list',body)
  }

  get loaderEnabled() {
    return CommonService.loaderEnabled;
  }

  public static showLoader() {
    setTimeout(() => {
      this.loaderEnabled = true;
    }, 0);
  }

  public static hideLoader() {
    setTimeout(() => {
      this.loaderEnabled = false;
    }, 0);
  }

  public static convertInputToDesiredFormat(parsedInput: any[]): string {
    if (!Array.isArray(parsedInput)) {
      console.error("Input must be a JSON array");
      return null;
    }

    const result: { [key: string]: boolean } = {};

    parsedInput.forEach(item => {
      if (item.key && item.value !== undefined) {
        result[item.key] = item.value;
      } else {
        console.error("Each item must contain 'key' and 'value' properties");
      }
    });

    return JSON.stringify(result);
  }

  public static convertToPayload(dropdown_list) {
    let input: any;
    try {
      input = JSON.parse(dropdown_list);
    } catch (e) {
      console.error("Invalid JSON format");
      alert("Invalid JSON format. Please enter a valid JSON.");
      return null;
    }
    let data_dict: { [key: string]: any } = {};
    if (Array.isArray(input)) {
      for (let item of input) {
        if (item.name && item.value !== undefined) {
          data_dict[item.name] = item.value;
        } else {
          console.error("Array item must contain 'name' and 'value' properties");
          alert("Array item must contain 'name' and 'value' properties.");
          return null;
        }
      }
    } else if (typeof input === 'object') {
      data_dict = input;
    } else {
      console.error("Input must be a JSON object or array");
      alert("Input must be a JSON object or array.");
      return null;
    }
    return data_dict
  }

  public static enumToArray(enumObject, objectBody):any[] {
    return Object.keys(enumObject)
      .filter(key => !isNaN(Number(enumObject[key])))
      .map(key => ({ [objectBody.key1]: enumObject[key], [objectBody.key2]: key }));
  }

  public static enumCharToArray(enumObject: any): { id: string, name: string }[] {
    return Object.keys(enumObject).map(key => ({ id: key, name: enumObject[key] }));
  }

  public static generateFileUrl(base64Data: string, fileName: string): string | null {
    const binaryData = atob(base64Data);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const byteArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      byteArray[i] = binaryData.charCodeAt(i);
    }
    let contentType: string;

    const fileType = fileName.split('.').pop()?.toLowerCase();
    switch (fileType) {
      case 'pdf':
        contentType = 'application/pdf';
        break;
      case 'txt':
        contentType = 'text/plain';
        break;
      case 'edi':
          contentType = 'text/plain';
          break;
      case 'json':
        contentType = 'application/json';
        break;
      case 'xls':
        contentType = 'application/vnd.ms-excel';
        break;
      case 'xlsx':
        contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'docx':
        contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      case 'gif':
        contentType = 'image/gif';
        break;
      case 'jpg':
      case 'jpeg':
        contentType = 'image/jpeg';
        break;
      case 'png':
        contentType = 'image/png';
        break;
      case 'xml': // Added case for XML
        contentType = 'application/xml';
        break;
      default:
        console.error('Unsupported file type.');
        return null;
    }

    const blob = new Blob([arrayBuffer], { type: contentType });
    return window.URL.createObjectURL(blob);
  }

  public static openFileInNewTab(url: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.click();
    window.URL.revokeObjectURL(url);
  }

  public static convertToFormData(formValue: any,fileKey=null): FormData {
    const formData = new FormData();
    for (const key in formValue) {
      if (formValue.hasOwnProperty(key)) {
        if (key === fileKey) {
          formValue[key]?.forEach((file: any) => {
            formData.append(key, file);
          });
        }
        else if (formValue[key] == null) {
          formData.append(key, '');
        }
        else if (typeof formValue[key] === 'object' && !(formValue[key] instanceof File)) {
          formData.append(key, JSON.stringify(formValue[key] ?? ''));
        } else {
          formData.append(key, formValue[key] ?? '');
        }
      }
    }
    return formData;
  }

  public static getPrivilegeList() {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetails) {
      return userDetails?.privileges;
    }
  }

  public static getSuperUser() {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetails) {
      return userDetails?.is_superuser;
    }
  }

  public static estimateWidthFromWordCount(wordCount, avgCharPerWord = 5, pxPerChar = 7, pxPerSpace = 7) {
    if (wordCount === 0) {
      return 100;
    }
    let totalChars = wordCount * avgCharPerWord;
    let charWidth = totalChars * pxPerChar;
    let spaceWidth = (wordCount - 1) * pxPerSpace;
    return charWidth + spaceWidth;
}
}
